import React, { useEffect, useState } from 'react';
import { motion, useSpring, useTransform } from 'framer-motion';
interface CountUpProps {
  from?: number;
  to: number;
  duration?: number;
  delay?: number;
  prefix?: string;
  suffix?: string;
  decimals?: number;
  className?: string;
}
export const CountUp: React.FC<CountUpProps> = ({
  from = 0,
  to,
  duration = 2,
  delay = 0.2,
  prefix = '',
  suffix = '',
  decimals = 0,
  className = ''
}) => {
  const [isInView, setIsInView] = useState(false);
  // Use a spring animation for smooth counting
  const springValue = useSpring(from, {
    stiffness: 50,
    damping: 30,
    duration: duration * 1000
  });
  // Transform the spring value to the target value
  const countValue = useTransform(springValue, value => {
    if (decimals === 0) {
      return Math.floor(value).toLocaleString();
    } else {
      return value.toFixed(decimals).toLocaleString();
    }
  });
  // Start the animation when component is in view
  useEffect(() => {
    if (isInView) {
      springValue.set(to);
    }
  }, [isInView, to, springValue]);
  return <motion.div className={className} initial={{
    opacity: 0.5
  }} animate={{
    opacity: 1
  }} onViewportEnter={() => setIsInView(true)} viewport={{
    once: true,
    margin: '-100px'
  }} data-id="element-735">
      {prefix}
      <motion.span data-id="element-736">{countValue}</motion.span>
      {suffix}
    </motion.div>;
};